<template>
  <div>
    <form>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-2">
          <label for="fiscalYear">Fiscal Year</label>
          <div class="p-field p-col-12 p-md-2">
            <span id="fiscalYear">{{ $store.getters.fyName }}</span>
          </div>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="employmentStatus">Employment Status</label>
          <InputText id="employmentStatus" v-model="employmentStatus" disabled/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="leaveType">Leave Type</label>
          <Dropdown v-model="leaveType" :options="leaveTypeList" optionLabel="value" placeholder="--Select--"
                    id="leaveType"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="leaveAllowed">Leave Allowed</label>
          <InputText id="leaveAllowed" v-model="leaveAllowed"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="actualLeaveValue">Actual Leave Value</label>
          <InputText id="actualLeaveValue" v-model="actualLeaveValue"/>
        </div>
      </div>
      <hr/>
      <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-5">
        <div class="p-field p-col-12 p-md-1">
          <Button class="p-button-raised" label="Save" icon="pi pi-save" @click.prevent="addLeaveAllocation"/>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'

export default {
  name: 'leaveAllocation',
  data() {
    return {
      name: '',
      leaveType: {},
      employmentStatus: '',
      filters: {},
      leaveAllowed: 0,
      actualLeaveValue: 0,
      dateOfBirth: null,
      englishDateEnabled: true,
      loading: false,
      editing: false,
      holidayId: null
    }
  },
  computed: {
    leaveTypeList() {
      return this.$store.state.hr.leaveTypeList
    }
  },
  mounted() {
    this.findLeaveTypeList()
  },
  methods: {
    async findLeaveTypeList() {
      await this.$store.dispatch('loadHrMasterSetupList', 'LeaveType')
    },
    async addLeaveAllocation() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let holiday = {
        id: this.holidayId,
        value: this.name
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrMasterSetup', holiday)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', holiday)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    reset() {
      this.name = ''
    }
  },
  components: {
    Button,
    InputText,
    Dropdown
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// leaveAllocation.vue?3e2bf68a